import { render, staticRenderFns } from "./PhasesFormTab.vue?vue&type=template&id=66a9e965"
import script from "./PhasesFormTab.vue?vue&type=script&lang=js"
export * from "./PhasesFormTab.vue?vue&type=script&lang=js"
import style0 from "./PhasesFormTab.vue?vue&type=style&index=0&id=66a9e965&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports